import { Component, Input, OnInit } from '@angular/core';
import { CreditCard } from '../../../models/credit-card';
import { IconEnum } from '../../../enum/icon.enum';
import { IconComponent } from '../../shared/icon/icon.component';

@Component({
    selector: 'app-credit-card-display',
    templateUrl: './credit-card-display.component.html',
    styleUrls: ['./credit-card-display.component.scss'],
    imports: [IconComponent]
})
export class CreditCardDisplayComponent implements OnInit {

    @Input()
    public creditCard: CreditCard;

    public icon: IconEnum;

    constructor() {
    }

    ngOnInit(): void {
        switch (this.creditCard.issuer) {
            case 'VISA':
                this.icon = 'cc-visa';
                break;
            case 'MASTERCARD':
                this.icon = 'cc-mastercard';
                break;
            case 'JCB':
                this.icon = 'cc-jcb';
                break;
            case 'DISCOVER':
                this.icon = 'cc-discover';
                break;
            case 'AMEX':
                this.icon = 'cc-amex';
                break;
            default:
                this.icon = 'credit-card';
                break;
        }
    }

}
